
import AuthImage from '@/components/image/AuthImage.vue'
import JigTooltip from '@/components/input/JigTooltip.vue'
import LibraryFilters from '@/components/input/LibraryFilters.vue'
import SearchField from '@/components/input/SearchField.vue'
import DataTable from '@/components/material/DataTable.vue'
import LibraryCertificatesModal from '@/components/modals/LibraryCertificatesModal.vue'
import PromptYesNo from '@/components/modals/PromptYesNo.vue'
import { UtilsConst } from '@/constants'
import { TeamLibraryConst } from '@/constants/teamlibrary'
import FilterMixin from '@/mixin/Filters'
import LibraryMixin from '@/mixin/Library'
import UploadModelDialog from '@/modules/library/components/UploadModelDialog.vue'
import { DataTableHeading, DataTableHeadings } from '@/modules/library/types'
import { Permissions } from '@/security/permissions'
import { PermissionActions } from '@/store/constants'
import { Tenant } from '@/store/modules/app/types'
import { LibraryCategories, LibraryCategory, LibraryCategorySelectItem, LibraryEntry } from '@/store/modules/teamlibrary/types'
import { DynaconfConfig, Namespace, StandardObject } from '@/store/types'
import { CategoryHelpers } from '@/utils/category-helpers'
import { TenantHelpers } from '@/utils/tenant-helpers'
import IconApi from '@svg/IconApi.svg'
import IconBin from '@svg/IconBin.svg'
import IconPencil from '@svg/IconPencil.svg'
import IconUploadCloud from '@svg/IconUploadCloud.svg'
import { mixins } from 'vue-class-component'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation, State } from 'vuex-class'

const defaultFilter: Record<string, any> = {}

@Component({
  components: {
    AuthImage,
    DataTable,
    IconApi,
    IconBin,
    IconPencil,
    IconUploadCloud,
    JigTooltip,
    LibraryCertificatesModal,
    LibraryFilters,
    PromptYesNo,
    SearchField,
    UploadModelDialog,
  },
})
export default class LibraryVue extends mixins(FilterMixin, LibraryMixin) {
  @State('dynaconfConfig', { namespace: Namespace.App })
  public dynaconfConfig!: DynaconfConfig
  @State('modelsLibrary', { namespace: Namespace.TeamLibrary })
  public modelsLibrary!: LibraryEntry[]
  @State('modelsLibraryTags', { namespace: Namespace.TeamLibrary })
  public modelsLibraryTags!: string[]
  @State('myTenantIndex', { namespace: Namespace.App })
  public myTenantIndex!: number
  @State('myTenants', { namespace: Namespace.App })
  public myTenants!: Tenant[]
  @State('currentPage', { namespace: Namespace.TeamLibrary })
  public currentPage!: number
  @State('itemsPerPage', { namespace: Namespace.TeamLibrary })
  public itemsPerPage!: number
  @State('totalPages', { namespace: Namespace.TeamLibrary })
  public totalPages!: number
  @State('totalRows', { namespace: Namespace.TeamLibrary })
  public totalRows!: number

  @Getter('isPreparingApp', { namespace: Namespace.Utils })
  public isPreparingApp!: boolean
  @Getter('allowedModelFileFormats', { namespace: Namespace.App })
  public allowedModelFileFormats!: string[]

  @Mutation('updateLibListCurrentPage', { namespace: Namespace.TeamLibrary })
  public updateLibListCurrentPage: any
  @Mutation('updateLibraryItemsPerPage', { namespace: Namespace.TeamLibrary })
  public updateLibraryItemsPerPage: any

  @Action('loadTenantsLibrary', { namespace: Namespace.TeamLibrary })
  public loadTenantsLibrary: any
  @Action('deleteLibraryEntryById', { namespace: Namespace.TeamLibrary })
  public deleteLibraryEntryById: any
  @Action('loadFileSpaceUsed', { namespace: Namespace.App })
  public loadFileSpaceUsed: any

  public $refs!: Vue['$refs'] & {
    deleteItemPromptYesNo: PromptYesNo
  }

  private globalHeadersPart1: DataTableHeadings = {
    ThumbnailUrl: {
      copy: 'Preview',
      sort: false,
    },
    DisplayName: {
      copy: 'Name',
      sort: true,
      sortByQuery: 'display_name',
      isAsc: true,
    },
    Id: {
      copy: 'Id',
      sort: true,
      sortByQuery: 'id',
      isAsc: true,
    },
    Tags: {
      copy: 'Tags',
      sort: true,
      sortByQuery: 'tags',
      isAsc: true,
    },
    Categories: {
      copy: 'Categories',
      sort: true,
      sortByQuery: 'categories',
      isAsc: true,
    },
  }
  private globalHeadersPart2: DataTableHeadings = {
    DateUpdated: {
      copy: 'Updated',
      sort: true,
      sortByQuery: 'date_updated',
      isAsc: false,
    },
    action: {
      sortingAction: [
        {
          key: 'DateUpdated',
          isAsc: false,
          text: 'Newest first',
        },
        {
          key: 'DateUpdated',
          isAsc: true,
          text: 'Oldest first',
        },
        {
          key: 'DisplayName',
          isAsc: true,
          text: 'A - Z',
        },
        {
          key: 'DisplayName',
          isAsc: false,
          text: 'Z - A',
        },
        {
          key: 'TriangleCount',
          sortByQuery: 'triangle_count',
          isAsc: false,
          text: 'Most triangles',
        },
        {
          key: 'TriangleCount',
          sortByQuery: 'triangle_count',
          isAsc: true,
          text: 'Fewest triangles',
        },
      ],
      sort: false,
    },
  }
  private jigStaffOnlyHeaders: DataTableHeadings = {
    ...this.globalHeadersPart1,
    Visibility: {
      copy: 'Visibility',
      sort: true,
      sortByQuery: 'visibility',
      isAsc: true,
    },
    ...this.globalHeadersPart2,
  }
  private allModelLibraryHeaders: DataTableHeadings = {
    ...this.globalHeadersPart1,
    ...this.globalHeadersPart2,
  }
  private myLibSort: Record<string, any> = {
    sortBy: 'DateUpdated',
    sortByQuery: 'date_updated',
    isAsc: false,
  }

  private readonly stateIdHidden = TeamLibraryConst.LibraryCategoriesStateId.Hidden
  private readonly stateIdDeprecated = TeamLibraryConst.LibraryCategoriesStateId.Deprecated
  private rowsSelected: any = []
  private rowsSelectedJigs: any = []
  private searchCriteria: string = ''
  private searchKeyFilters: Record<string, string>[] = [
    {
      key: 'display_name',
      op: 'like',
    },
  ]
  private selectedItem: any = { Id: '', DisplayName: '' }
  private canCreate: boolean = false
  private canView: boolean = false
  private canEdit: boolean = false
  private canDelete: boolean = false
  private isJigSpaceStaff: boolean = false
  private initializingLibraryListData: boolean = false
  private isLibraryListDataLoaded: boolean = false
  private showCertificatesModal: boolean = false
  // Active filter criteria for library listing. Each filter has format: { op: string, value: string }
  // Converted to query params by tenantLibraryPayload as: fieldName[operator]=value
  //
  // Examples:
  // - visibility: { op: 'eq', value: 'tenant' } for regular users, { op: 'any', value: 'public,tenant,private' } for JigSpaceStaff
  // - tags: { op: 'intersects', value: 'furniture,chair' }
  // - categories: { op: 'contains', value: '1' }
  // - display_name: { op: 'like', value: 'searchTerm' }
  //
  // Updated by LibraryFilters component, search field, and clear/reset actions.
  // Visibility filter is set dynamically via checkPermissions() based on user type.
  private libFilters: Record<string, any> = {
    ...defaultFilter,
  }

  @Watch('initializing')
  private async onInitializingChanged(value: boolean) {
    if (!value && !this.isLibraryListDataLoaded) {
      await this.initLibraryListData()
    }

    this.checkPermissions()
  }

  protected async created() {
    if (this.initializing) return

    await this.initLibraryListData()
  }

  protected mounted() {
    this.checkPermissions()
  }

  // Override the hook method
  protected async onAfterTenantChanged(): Promise<any> {
    this.checkPermissions()
    if (this.isLibraryListDataLoaded) {
      if (this.canView) {
        this.loadTenantsLibrary(this.tenantLibraryPayload)
      }
    } else {
      await this.initLibraryListData()
    }
  }

  private async initLibraryListData() {
    if (this.initializingLibraryListData) return

    this.initializingLibraryListData = true
    this.isLibraryListDataLoaded = false

    // Check if user is JigSpace Staff to determine if we should load public categories
    const tenant = TenantHelpers.GetTenantByIndex(this.myTenantIndex, this.myTenants)

    if (tenant == null || tenant.ID === TenantHelpers.InvalidTenantID) {
      this.initializingLibraryListData = false
      return
    }

    this.isJigSpaceStaff = TenantHelpers.IsTenantJigSpaceStaff(tenant)

    // Load tenant categories and optionally public categories (if JigSpace Staff)
    const promiseTenantCategories = this.loadLibraryCategories(this.myTenant.ID)
    const promisePublicCategories = this.isJigSpaceStaff ? this.loadLibraryCategories() : Promise.resolve(true)

    const results = await Promise.all([promiseTenantCategories, promisePublicCategories])
    if (results.every((result) => result)) {
      await this.loadTenantsLibrary(this.tenantLibraryPayload)
      this.isLibraryListDataLoaded = true
    }

    this.initializingLibraryListData = false
  }

  /**
   * Constructs the query payload sent to the API when loading tenant library entries.
   * Combines pagination (limit), sorting, and active filters into a single request object.
   *
   * The payload structure:
   * - limit: number of items per page
   * - sort: 'field_name,direction' (e.g., 'date_updated,desc')
   * - filters: transformed from libFilters as 'fieldName[operator]=value'
   *
   * Example payloads:
   *
   * 1. Default load for regular user (no filters, sorted by date):
   *    {
   *      limit: 50,
   *      sort: 'date_updated,desc',
   *      'visibility[eq]': 'tenant'
   *    }
   *
   * 2. Default load for JigSpaceStaff with tag and category filters:
   *    {
   *      limit: 50,
   *      sort: 'display_name,asc',
   *      'visibility[any]': 'public,tenant,private',
   *      'tags[intersects]': 'furniture,chair',
   *      'categories[contains]': '1'
   *    }
   *
   * 3. With search (search adds display_name filter only):
   *    {
   *      limit: 100,
   *      sort: 'date_updated,desc',
   *      'visibility[eq]': 'tenant',
   *      'display_name[like]': 'table'
   *    }
   */
  private get tenantLibraryPayload(): Record<string, any> {
    const payload: Record<string, any> = {
      limit: this.itemsPerPage,
      sort: `${this.myLibSort.sortByQuery},${this.myLibSort.isAsc ? 'asc' : 'desc'}`,
      page: this.currentPage,
    }

    for (const key in this.libFilters) {
      const { op, value } = this.libFilters[key]

      payload[`${key}[${op}]`] = value
    }

    return payload
  }

  private get libraryCategoryItems(): LibraryCategorySelectItem[] {
    return CategoryHelpers.buildCategorySelectItems({
      tenantCategories: this.libraryCategories,
      publicCategories: this.libraryPublicCategories,
      includePublic: this.isJigSpaceStaff,
      hiddenStateId: this.stateIdHidden,
      deprecatedStateId: this.stateIdDeprecated,
    })
  }

  private get allowedModelFormatsInfo(): string {
    return this.allowedModelFileFormats.join(' / ').toUpperCase()
  }

  private get myModelLibraryHeaders() {
    if (this.isJigSpaceStaff) {
      return this.jigStaffOnlyHeaders
    } else {
      return this.allModelLibraryHeaders
    }
  }

  private get searchEvents(): any {
    return UtilsConst.searchEvents
  }

  private async deleteItem() {
    if (await this.deleteLibraryEntryById(this.selectedItem.Id)) {
      this.loadTenantsLibrary(this.tenantLibraryPayload)
      // Library objects list changed, refresh space used value
      this.loadFileSpaceUsed()
    }
  }

  private onUploadSuccess() {
    this.loadTenantsLibrary(this.tenantLibraryPayload)
    // Library objects list changed, refresh space used value
    this.loadFileSpaceUsed()
  }

  private showDeleteItemPrompt(item: any) {
    this.selectedItem = item
    this.$refs.deleteItemPromptYesNo.ShowPrompt()
  }

  private checkPermissions() {
    this.canCreate = false
    this.canView = false
    this.canEdit = false
    this.canDelete = false

    const tenant = TenantHelpers.GetTenantByIndex(this.myTenantIndex, this.myTenants)

    if (tenant == null || tenant.ID === TenantHelpers.InvalidTenantID) return

    this.isJigSpaceStaff = TenantHelpers.IsTenantJigSpaceStaff(tenant)

    const tenantTokens = this.$auth0.tenants
    const tenantToken = TenantHelpers.GetTenantTokenByTenantID(tenantTokens, tenant.ID)

    if (tenantToken == null) return

    this.canCreate = Permissions.TokenHasPermissionAction(tenantToken, Permissions.PermLibrary, PermissionActions.Create)
    this.canView = Permissions.TokenHasPermissionAction(tenantToken, Permissions.PermLibrary, PermissionActions.View)
    this.canEdit = Permissions.TokenHasPermissionAction(tenantToken, Permissions.PermLibrary, PermissionActions.Edit)
    this.canDelete = Permissions.TokenHasPermissionAction(tenantToken, Permissions.PermLibrary, PermissionActions.Delete)
  }

  private showUploadLibraryEntryDialog() {
    ;(this.$refs.uploadModelDialog as any).showDialog()
  }

  private showImportCertificateDialog() {
    this.showCertificatesModal = true
  }

  /**
   * Updates library filters using the current search criteria.
   * Sets the 'display_name' filter (op 'like') based on searchCriteria.
   * It's case insensitive.
   *
   * Note: searchCriteria now applies only to display_name. Tags are no longer
   * affected by search and are only managed via the LibraryFilters component.
   *
   * Example: If searchCriteria is "table", this sets:
   *   display_name[like] = "*table*"
   */
  private setLibFiltersUsingSearch() {
    for (const filter of this.searchKeyFilters) {
      this.$set(this.libFilters, filter.key, {
        op: filter.op,
        value: `*${this.searchCriteria}*`, // use wildcard for partial match
      })
    }
  }

  private searchObjects(searchCriteria: string) {
    this.searchCriteria = searchCriteria

    // Only add search filters if searchCriteria is not empty
    // Empty search should not add empty-valued query params
    if (searchCriteria) {
      this.setLibFiltersUsingSearch()
    } else {
      // Remove search filters when searchCriteria is empty
      this.searchKeyFilters.forEach((filter: Record<string, string>) => {
        this.$delete(this.libFilters, filter.key)
      })
    }

    this.loadTenantsLibrary(this.tenantLibraryPayload)
  }

  /**
   * Resets the library list by clearing search criteria and related filters.
   * Triggered when user clicks the clear/reset button in the search field.
   *
   * This clears only the filters added by the search field (as defined in searchKeyFilters),
   * preserving other filters set via the LibraryFilters component (e.g., tags, categories, visibility).
   *
   * Example: If searchKeyFilters contains { key: 'display_name', op: 'like' },
   * this will remove the display_name[like] filter but keep other active filters intact.
   */
  private resetLibraryList() {
    this.rowsSelected = []
    this.rowsSelectedJigs = []

    this.searchKeyFilters.forEach((filter: Record<string, string>) => {
      this.$delete(this.libFilters, filter.key)
    })

    this.searchCriteria = ''

    this.loadTenantsLibrary(this.tenantLibraryPayload)
  }

  /**
   * Updates library filters when a filter value is changed in the LibraryFilters component.
   * Triggered when user selects/changes any filter (tags, category, visibility, date).
   *
   * Special handling for 'tags' field:
   * - The searchCriteria also covers the 'tags' field, so we need to prevent overwriting search-set tags
   * - When updating the tags filter, if tags already exist (set by search), the new filter value is APPENDED
   * - This ensures: filter only updates/removes values set by filter, search only updates/removes values set by search
   * - The check `key === 'tags' && this.libFilters[key] != null` preserves any existing search-based tag values
   *
   * Example: If user searched for "chair" (tags contains "chair") then filters by tag "furniture",
   * tags filter becomes "chair,furniture" instead of just "furniture"
   *
   * @param data - Object containing key (filter field name), op (operator), and value (filter value)
   */
  private filterUpdated(data: any) {
    const { key, op, value } = data

    if (this.libFilters[key] != null && (value == null || value === '')) {
      this.$delete(this.libFilters, key)
    } else if (value != null && value !== '') {
      let filterValues = value

      if (key === 'tags' && this.libFilters[key] != null) {
        filterValues = `${this.libFilters[key].value},${filterValues}`
      }

      this.$set(this.libFilters, key, {
        op,
        value: filterValues,
      })
    }

    this.updateLibListCurrentPage(1)

    this.$nextTick(() => {
      this.loadTenantsLibrary(this.tenantLibraryPayload)
    })
  }

  private filterCleared() {
    this.$set(this, 'libFilters', {
      ...defaultFilter,
    })

    this.updateLibListCurrentPage(1)

    if (this.searchCriteria) {
      this.setLibFiltersUsingSearch()
    }

    // Note: visibility filter will be set by LibraryFilters emitting default after filter-cleared,
    // and filterUpdated will trigger the reload to avoid duplicate requests.
  }

  private onSortChange(sortPayload: StandardObject) {
    if (sortPayload.sorted) {
      return
    }

    if (sortPayload.sortByQuery) {
      this.myLibSort.sortBy = sortPayload.sortId
      this.myLibSort.sortByQuery = sortPayload.sortByQuery
      this.myLibSort.isAsc = sortPayload.isSortingAsc

      if (this.jigStaffOnlyHeaders[sortPayload.sortId] && this.jigStaffOnlyHeaders[sortPayload.sortId].sort) {
        ;(this.jigStaffOnlyHeaders[sortPayload.sortId] as DataTableHeading<true>).isAsc = sortPayload.isSortingAsc
      }

      if (this.allModelLibraryHeaders[sortPayload.sortId] && this.allModelLibraryHeaders[sortPayload.sortId].sort) {
        ;(this.allModelLibraryHeaders[sortPayload.sortId] as DataTableHeading<true>).isAsc = sortPayload.isSortingAsc
      }
    }

    this.loadTenantsLibrary(this.tenantLibraryPayload)
  }

  private itemsPerPageChange(payload: any) {
    this.updateLibraryItemsPerPage(payload.newItemsPerPage)
    this.loadTenantsLibrary(this.tenantLibraryPayload)
  }

  private onLibListPageChange(newPage: number) {
    this.updateLibListCurrentPage(newPage)
    this.loadTenantsLibrary(this.tenantLibraryPayload)
  }

  private selectAllRowsChanged(payload: any) {
    this.rowsSelected = payload.rowsSelected
    this.rowsSelectedJigs = payload.rowsSelectedItems
  }

  private onLibSelectChange(payload: any) {
    this.rowsSelected = payload.rowsSelected
    this.rowsSelectedJigs = payload.rowsSelectedItems
  }
}
